import { useGraphQLResponseMessage } from '@/src/components/hooks/useGraphqlResponseMessage';
import { getUserIdsForConnectedUserAvatars } from '@/src/displayUtils/ConnectedUsersDisplay';
import { useSelectedRole } from '@/src/features/auth/hooks';
import { useSearchQuery } from '@/src/generated/operations/SearchQuery.generated';

export const useSearchQueryData = (searchValue: string) => {
  const { role } = useSelectedRole();

  const [query] = useSearchQuery({
    pause: !searchValue,
    variables: { searchValue },
  });

  useGraphQLResponseMessage(query, {
    errorMessage: 'Error searching for activities',
  });

  const assignedActivities = searchValue ? (query.data?.searchContent ?? []) : [];

  return {
    assignedActivities: assignedActivities.map(activity => ({
      ...activity,
      userIds: getUserIdsForConnectedUserAvatars(
        activity.learner.id,
        activity.latestEvaluator?.id ?? null,
        role,
      ),
    })),
    fetching: query.fetching,
  };
};

export type SearchedAssignedActivity = ReturnType<
  typeof useSearchQueryData
>['assignedActivities'][number];
